export const setLoggedIn = (loggedIn) => ({
  type: 'SET_LOGGED_IN',
  loggedIn,
});

export const setUserInfo = (user) => ({
  type: 'SET_USER_INFO',
  user,
});

export const clearUserInfo = () => ({
  type: 'CLEAR_USER_INFO',
});

export const setMeetings = (meetings) => ({
  type: 'SET_MEETINGS',
  meetings,
});

export const setAggregateMetrics = (metrics) => ({
  type: 'SET_METRICS',
  metrics,
});
